/* eslint-disable */
export default {
  noActiveCalls: '無使用中通話',
  noRecords: '找不到結果。',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
